export const SUGGESTED_DEAL_LIST_UPDATE = 'SUGGESTED_DEAL_LIST_UPDATE';
export const SUGGESTED_DEAL_UPDATE = 'SUGGESTED_DEAL_UPDATE';
export const UPDATE_SELECTED_SUGGESTED_DEAL = 'UPDATE_SELECTED_SUGGESTED_DEAL';
